import { useEffect, useState, createContext } from "react";
import { useParams } from "react-router-dom";
import * as api from "../api/api";
import RenderSection from "../Components/Agent/RenderSection";
import { Form } from "react-bootstrap";
import { Snackbar, Alert } from "@mui/material";
import { useLanguage } from "../Components/Localization/LanguageContext";
import strings from "../Components/Localization/strings";
export const AdminMyContext = createContext([]);

export default function PreviewForm() {
  const { language } = useLanguage();
  const pageTitle = "PreviewForm";
  const { id } = useParams();
  const [form, setForm] = useState({});
  const [processDetails, setProcessDetails] = useState([]);
  const [parentSelectionValues, setParentSelectionValues] = useState({});
  const [snackbarData, setSnackbarData] = useState({
    show: false,
    message: "",
    severity: "success",
  });
  console.log(id);

  useEffect(() => {
    api.getFormById(id).then((response) => {
      // map the form.section(forEach).sectionFields(forEach).field(forEach)'s property "layoutId" to one in the fieldLayouts array
      // then create a new property "fieldLayout"

      /*response.data.object.sections.forEach((section) => {
        section.sectionFields.forEach((field) => {
          let layoutId = field.fieldTypeId;
          let fieldLayouts = field.field.fieldType.fieldLayouts;

          let fieldLayout = fieldLayouts.filter(
            (layout) => layout.fieldLayoutId === layoutId
          )[0];
          field.field = { ...field.field, fieldLayout };
        });
      });*/
      setForm(response.data.object);
    });
  }, [id]);

  function validateForm(e) {
    e.preventDefault();
    const formElement = e.currentTarget;
    if (formElement.querySelector(".is-invalid") || formElement.checkValidity() === false) {
      e.stopPropagation();
      setSnackbarData({
        ...snackbarData,
        message: "Some fields are invalid!",
        show: true,
        severity: "error",
      });
      return;
    }
    setSnackbarData({
      ...snackbarData,
      message: strings[pageTitle][language].fieldsAreValidMessage,
      show: true,
      severity: "success",
    });
  }

  return (
    <div>
      <div style={{ backgroundColor: "#00a0e537" }}>
        <div className="nav-bar">
          <h3 style={{ fontWeight: "bold" }}>
            {strings[pageTitle][language].pageName}
          </h3>
        </div>
        <h2
          style={{
            color: "#00a0e5",
            fontWeight: "normal",
            margin: 20,
          }}
        >
          {form.name}
        </h2>
        <hr
          style={{
            height: "4px",
            border: "none",
            color: "#000",
            backgroundColor: "#000",
          }}
        ></hr>
      </div>

      <Form onSubmit={validateForm}>
        <AdminMyContext.Provider
          value={{
            processDetails,
            setProcessDetails,
            parentSelectionValues,
            setParentSelectionValues,
          }}
        >
          <div className="process-grid">
            {form.sections &&
              form.sections
                .sort((a, b) => {
                  if (a.rank !== b.rank) {
                    return a.rank - b.rank; // Ascending order for rank
                  }
                  const aDate = new Date(a.created);
                  const bDate = new Date(b.created);
                  return aDate - bDate;
                })
                .map((section) => {
                  return (
                    <RenderSection
                      section={section}
                      key={section.sectionId}
                      isAdmin={true}
                      isPreview
                    />
                  );
                })}
          </div>
        </AdminMyContext.Provider>
        <hr
          style={{
            height: "4px",
            border: "none",
            color: "#000",
            backgroundColor: "#000",
          }}
        ></hr>

        <div style={{ display: "flex", justifyContent: "flex-end" }}>
          <button
            className="button-round"
            style={{ margin: "0.5em" }}
            type="submit"
          >
            {strings[pageTitle][language].testValidation}
          </button>
          <button
            className="button-round"
            style={{ margin: "0.5em", width: 100 }}
            onClick={() => {
              window.close();
            }}
          >
            {strings[pageTitle][language].closeButtonLabel}
          </button>
        </div>
      </Form>
      <Snackbar
        anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
        open={snackbarData.show}
        autoHideDuration={3000}
        onClose={() => setSnackbarData({ ...snackbarData, show: false })}
      >
        <Alert severity={snackbarData.severity}>{snackbarData.message}</Alert>
      </Snackbar>
    </div>
  );
}
